import { store } from '../store';
import { locales } from '../locales';

export function useLocale() {
  const state = store.getState();
  const key = formatLocale(String(state.config.language));
  const locale = locales[key] || locales.en_US;
  return locale;
}

// Ensure the language code is formatted as 'aa_AA'.
function formatLocale(locale: string) {
  return locale.replace(
    /(\w+)(_|-)(\w+)/g,
    (string, language, separator, variant) => `${language.toLowerCase()}_${variant.toUpperCase()}`
  );
}
